import { useRouter } from "next/navigation";
import { VoteTemplate } from "~/components/Templates/Vote/VoteTemplate";
import { useInfiniteScroll } from "~/hooks/useInfiniteScroll";
import { useSearch } from "~/hooks/useSearch";

export const VoteContainer = () => {
  const router = useRouter();
  const {
    searchText,
    setSearchText,
    isSearchMode,
    serchResultCount,
    setSerchResultCount,
    setIsSearchMode,
  } = useSearch("VOTE");

  const {
    datas: votes,
    hasMoreData,
    isLoading,
    setDatas,
    setLastTimestamp,
    setIsLoading,
    resetDatas,
  } = useInfiniteScroll({ dataType: "VOTE", take: 10, searchText });

  const onSearch = (searchText: string) => {
    setIsLoading(true);
    setDatas([]);
    setLastTimestamp(new Date());
    void setSearchText(searchText);
  };

  const voteTemplateProps: React.ComponentProps<typeof VoteTemplate> = {
    voteHeaderModuleProps: {
      isSearchMode,
      searchTopBarProps: {
        serchResultCount,
        onSearch: onSearch,
        onCloseClicked: () => {
          resetDatas();
          setSerchResultCount(undefined);
          setSearchText("");
          setIsSearchMode(false);
        },
      },
      titleTopBarProps: {
        title: "Vote",
        topBarIconProps: [
          {
            iconName: "history",
            href: "/pointHistory",
          },
          {
            iconName: "search",
            onClick: () => {
              setIsSearchMode(true);
            },
          },
          // {
          //   iconName: "plus",
          //   href: "/voteReg/0",
          // },
        ],
      },
    },
    voteCardListModuleProps: { votes, isLoading, hasMoreData },
  };

  return <VoteTemplate {...voteTemplateProps} />;
};
